import React, { useEffect, useState } from 'react';

import { resolveGeoLocation } from 'flow/actions/geolocation-actions';
import NotifierBanner from 'flow/components/custom-components/NotifierBanner';
import useAppContext from 'flow/hooks/useAppContext';
import useGeoLocationRetry from 'flow/hooks/useGeoLocationRetry';
import { useAppDispatch } from 'flow/hooks/useRedux';
import {
    GeoLocationPermission,
    GeoLocationPermissionType,
    canOpenLocationSettings,
    openLocationSettings,
    watchGeoLocationPermissionState,
} from 'flow/utils/geolocation-utils';

const GeoLocationPermissionBanner = () => {
    const dispatch = useAppDispatch();
    const { i18next } = useAppContext();
    const [permission, setPermission] =
        useState<GeoLocationPermissionType | null>(null);

    useEffect(() => watchGeoLocationPermissionState(setPermission), []);
    useGeoLocationRetry(permission);

    if (canOpenLocationSettings()) {
        return (
            <NotifierBanner
                message={i18next.t('permission.location.not_granted_desktop')}
                buttonText={i18next.t('settings')}
                handleClick={openLocationSettings}
                theme={'warning'}
            />
        );
    }

    if (permission === GeoLocationPermission.DENIED) {
        return (
            <NotifierBanner
                message={i18next.t('permission.location.blocked')}
                theme={'warning'}
            />
        );
    }

    if (permission === null) {
        return (
            <NotifierBanner
                message={i18next.t('permission.location.not_granted')}
                theme={'warning'}
            />
        );
    }

    return (
        <NotifierBanner
            message={i18next.t('permission.location.not_granted')}
            buttonText={i18next.t('permission.location.allow')}
            handleClick={() => dispatch(resolveGeoLocation())}
            theme={'warning'}
        />
    );
};

export default GeoLocationPermissionBanner;
